import { forwardRef } from "react";

import {
  type THeaderMenuLinkProps,
} from "@/ui/components/navigation/Header/Header.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextControl } from "@/ui/components/typography/TextControl";
import { cn } from "@/ui/lib/utils";
import Link from "next/link";

export const HeaderMenuLink = forwardRef<
  HTMLAnchorElement,
  THeaderMenuLinkProps
>(({ children, className, icon, ...props }, ref) => (
  <Link
    {...props}
    ref={ref}
    data-component="HeaderMenuLink"
    className={cn(
      "group flex select-none items-center gap-2 rounded-sys-full p-2 font-sys-default text-sys-sm leading-none text-foreground no-underline outline-none transition-colors hover:bg-component-interactive-hover focus:bg-component-interactive-hover h-11",
      className,
    )}
  >
    { icon ? (
      <Icon
        icon={icon}
        size="sm"
        aria-hidden="true"
        className="group-hover:[&_svg]:fill-sys-chartreuse-600 group-hover:[&_svg]:stroke-foreground"
      />
    ) : null }
    <TextControl size={2} isResponsive={false}>
      { children }
    </TextControl>
  </Link>
));

HeaderMenuLink.displayName = "HeaderMenuLink";
